// Scripts librairies
import toastr from 'toastr'
import { MarkerClusterer } from '@googlemaps/markerclusterer' // https://github.com/googlemaps/js-markerclusterer
import { dtectMap, loading, numberFormat } from '../libs/utils'

// Styles
import '../../scss/components/toast'

// Setup
const settings = require('../../common.json')

class MarkerUtils {
  static isAdvancedMarkerAvailable (map) {
    return google.maps.marker && map.getMapCapabilities().isAdvancedMarkersAvailable === true
  }

  static isAdvancedMarker (marker) {
    return google.maps.marker && marker instanceof google.maps.marker.AdvancedMarkerElement
  }

  static setMap (marker, map) {
    if (this.isAdvancedMarker(marker)) {
      marker.map = map
    } else {
      marker.setMap(map)
    }
  }

  static getPosition (marker) {
    // SuperClusterAlgorithm.calculate expects a LatLng instance so we fake it for Adv Markers
    if (this.isAdvancedMarker(marker)) {
      if (marker.position) {
        if (marker.position instanceof google.maps.LatLng) {
          return marker.position
        }
        // since we can't cast to LatLngLiteral for reasons =(
        if (marker.position.lat && marker.position.lng) {
          return new google.maps.LatLng(marker.position.lat, marker.position.lng)
        }
      }
      return new google.maps.LatLng(null)
    }
    return marker.getPosition()
  }

  static getVisible (marker) {
    if (this.isAdvancedMarker(marker)) {
      /**
       * Always return true for Advanced Markers because the clusterer
       * uses getVisible as a way to count legacy markers not as an actual
       * indicator of visibility for some reason. Even when markers are hidden
       * Marker.getVisible returns `true` and this is used to set the marker count
       * on the cluster. See the behavior of Cluster.count
       */
      return true
    }
    return marker.getVisible()
  }
}

const groundsMap = {
  el: 'groundsMap',

  buildMap () {
    const groundsMap = document.getElementById(this.el)
    loading(groundsMap)
    const markers = []
    let map
    let center
    const form = document.querySelector('form[name="offersSearchForm"]')
    const data = new FormData()
    data.append('location', form.querySelector('input[name="location"]').value)
    data.append('type', form.querySelector('input[name="type"]').value)
    data.append('slug', form.querySelector('input[name="slug"]').value)
    data.append('surface_from', form.querySelector('input[name="surface_from"]').value)
    data.append('surface_to', form.querySelector('input[name="surface_to"]').value)
    data.append('budget_from', form.querySelector('input[name="budget_from"]').value)
    data.append('budget_to', form.querySelector('input[name="budget_to"]').value)
    fetch(document.location.origin + '/terrains-a-batir/get', {
      method: 'POST',
      headers: new Headers({
        'X-Requested-With': 'XMLHttpRequest'
      }),
      body: data
    }).then((response) => {
      toastr.remove()
      if (response.status === 200) {
        response.json().then((data) => {
          let countGrounds = 0
          let countCities = 0
          let infowindow
          const boxList = []
          let title
          let latLng
          let marker

          // affiche les terrains de tous les départements
          if (data.type === 'all') {
            if (typeof data.listing !== 'undefined') {
              /* global google */
              center = new google.maps.LatLng(49.0372777, 2.2136286)
              map = new google.maps.Map(groundsMap, {
                mapId: 'ac9537acd6aac9d2',
                zoomControl: true,
                maxZoom: 13,
                center,
                scrollwheel: false,
                streetViewControl: false,
                panControl: false,
                mapTypeControl: false,
                draggable: true,
                disableDoubleClickZoom: false,
                keyboardShortcuts: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP
              })
            }

            // passe chaque commune possédant au moins 1 terrain en revue
            data.listing.forEach((el, i) => {
              countGrounds += parseInt(el.total)
              title = el.total === 1 ? '1 terrain' : el.total + ' terrains'
              latLng = new google.maps.LatLng(el.lat, el.lon)

              const icon = document.createElement('img')
              icon.src = document.location.origin + '/assets/img/icons/map-marker-offer-48x48.png'

              // fabrique le marker
              marker = new google.maps.marker.AdvancedMarkerElement({
                position: latLng,
                content: icon,
                title: el.city + ' : ' + title,
                gmpClickable: true
              })

              // id n'est plus un paramètre de AdvancedMarkerElement donc on le rajoute en custom sur l'objet pour le retrouver plus tard
              marker.id = i

              // infobulle
              const boxText = document.createElement('div')
              boxText.id = i
              boxText.data = el
              boxText.innerHTML =
                '<div class="text-center" id="content"><span class="h6 text-uppercase d-block mb-2">' +
                el.city +
                '&nbsp;: <span class="text-primary">' +
                (el.total === 0 ? 'aucun terrain' : el.total === 1 ? '1 terrain' : el.total + ' terrains') +
                '</span></span>' +
                el.content +
                '<a class="btn btn-sm btn-primary mt-2" href="' +
                el.link +
                '">Voir toutes les offres disponibles</a></div>'
              boxList.push(boxText)
              infowindow = new google.maps.InfoWindow({
                enableEventPropagation: true
              })

              marker.addListener(
                'click',
                (function (marker) {
                  return function () {
                    infowindow.close()
                    infowindow.setContent(boxList[this.id])
                    infowindow.open(map, marker)
                  }
                })(marker, i)
              )
              // ajoute le marker à tous les markers
              markers.push(marker)
              countCities++
            })

            const countCitiesS =
              countCities > 0
                ? countCities === 1
                  ? 'dans 1 commune'
                  : 'dans ' + numberFormat(countCities, 0, '.', ' ') + ' communes'
                : ''
            const countGroundsS =
              countGrounds > 0
                ? countGrounds === 1
                  ? '1 terrain'
                  : numberFormat(countGrounds, 0, '.', ' ') + ' terrains'
                : 'aucun terrain'
            document.querySelectorAll('.countOffer').forEach((el) => {
              el.innerHTML = countCities === 0 && countGrounds === 0 ? 'aucun terrain' : countGroundsS + ' ' + countCitiesS
            })
            document.querySelectorAll('.countOffers').forEach((el) => {
              el.innerHTML = countGrounds
            })
          }

          // affiche les terrains à proximité de la ville
          if (data.type === 'city') {
            let found = false
            center = new google.maps.LatLng(groundsMap.getAttribute('map-lat'), groundsMap.getAttribute('map-lng'))
            map = new google.maps.Map(groundsMap, {
              mapId: 'ac9537acd6aac9d2',
              zoomControl: true,
              zoom: 12,
              maxZoom: 13,
              center,
              scrollwheel: false,
              streetViewControl: false,
              panControl: false,
              mapTypeControl: false,
              draggable: true,
              disableDoubleClickZoom: false,
              keyboardShortcuts: false,
              mapTypeId: google.maps.MapTypeId.ROADMAP
            })

            // passe chaque commune possédant au moins 1 terrain en revue
            data.listing.forEach((el, i) => {
              countGrounds += parseInt(el.total)
              title = el.total === 1 ? '1 terrain' : el.total + ' terrains'
              latLng = new google.maps.LatLng(el.lat, el.lon)

              const icon = document.createElement('img')
              icon.src = document.location.origin + '/assets/img/icons/map-marker-offer-48x48.png'

              const iconCurrent = document.createElement('img')
              iconCurrent.src = document.location.origin + '/assets/img/icons/map-marker-current-offer-48x48.png'

              // fabrique le marker
              marker = new google.maps.marker.AdvancedMarkerElement({
                position: latLng,
                content: el.lookup === true ? iconCurrent : icon,
                title: el.city + ' : ' + title,
                gmpClickable: true
              })

              // id n'est plus un paramètre de AdvancedMarkerElement donc on le rajoute en custom sur l'objet pour le retrouver plus tard
              marker.id = i
              // pareil pour link
              marker.link = el.link
              if (el.lookup === true) {
                found = true
              }

              // infobulle
              const boxText = document.createElement('div')
              boxText.id = i
              boxText.data = el
              boxText.innerHTML =
                '<div class="text-center" id="content"><span class="h6 text-uppercase d-block mb-2">' +
                el.city +
                '&nbsp;: <span class="text-primary">' +
                (el.total === 0 ? 'aucun terrain' : el.total === 1 ? '1 terrain' : el.total + ' terrains') +
                '</span></span>' +
                el.content +
                '<a class="btn btn-sm btn-primary mt-2" href="' +
                el.link +
                '">Voir tous les terrains disponibles</a></div>'
              boxList.push(boxText)
              infowindow = new google.maps.InfoWindow({
                enableEventPropagation: true
              })

              // ajoute le marker à tous les markers
              markers.push(marker)
              marker.addListener(
                'click',
                (function (marker) {
                  return function () {
                    infowindow.setContent(boxList[this.id])
                    infowindow.open(map, marker)
                  }
                })(marker, i)
              )
              countCities++
            })

            const iconGrey = document.createElement('img')
            iconGrey.src = document.location.origin + '/assets/img/icons/map-marker-disable-offer-48x48.png'

            // ajoute le marker de la ville recherchée si non trouvée dans le listing
            if (!found) {
              marker = new google.maps.marker.AdvancedMarkerElement({
                position: center,
                content: iconGrey,
                title: form.querySelector('input[name="location"]').value,
                gmpClickable: true
              })
              markers.push(marker)
            }
          }

          // dessine la carte ou affiche un message
          if (countGrounds > 0) {
            // eslint-disable-next-line no-unused-vars
            const mc = new MarkerClusterer({
              map,
              markers,
              // renderer: interpolatedRenderer
              renderer: {
                render ({ count, position }, stats, map) {
                  console.log('renderer')
                  // change color if this cluster has more markers than the mean cluster
                  const color = count > Math.max(10, stats.clusters.markers.mean) ? '#ff0000' : '#0000ff'
                  // create svg literal with fill color
                  const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
                    <circle cx="120" cy="120" opacity=".6" r="70" />
                    <circle cx="120" cy="120" opacity=".3" r="90" />
                    <circle cx="120" cy="120" opacity=".2" r="110" />
                    <text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="75" dominant-baseline="middle" font-family="outfit, roboto,arial,sans-serif">${count}</text>
                    </svg>`
                  const title = `Cluster of ${count} markers`
                  // adjust zIndex to be above other markers
                  const zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count
                  if (MarkerUtils.isAdvancedMarkerAvailable(map)) {
                    // create cluster SVG element
                    const div = document.createElement('div')
                    div.innerHTML = svg
                    const svgEl = div.firstElementChild
                    svgEl.setAttribute('transform', 'translate(0 25)')
                    const clusterOptions = {
                      map,
                      position,
                      zIndex,
                      content: svgEl,
                      title,
                      gmpClickable: true
                    }
                    return new google.maps.marker.AdvancedMarkerElement(clusterOptions)
                  } else {
                    // fallback si isAdvancedMarkerAvailable est false
                    const clusterOptions = {
                      position,
                      zIndex,
                      title,
                      icon: {
                        url: `data:image/svg+xml;base64,${btoa(svg)}`,
                        anchor: new google.maps.Point(25, 25)
                      }
                    }
                    return new google.maps.Marker(clusterOptions)
                  }
                }
              }
            })

            if (data.type === 'all') {
              // fit map to all markers
              const bounds = new google.maps.LatLngBounds()
              for (let i = 0; i < markers.length; i++) {
                bounds.extend(markers[i].position)
              }
              map.fitBounds(bounds)
              if (countCities === 1) {
                // si 1 seule ville, on dézoome pour éviter un zoom trop fort après le fit des clusters sur la map
                const listener = google.maps.event.addListener(map, 'idle', function () {
                  if (map.getZoom() > 16) map.setZoom(12)
                  google.maps.event.removeListener(listener)
                })
              }
            }
          } else {
            map.setZoom(12)
          }

          // auto-anchor
          const target = document.getElementById('go')
          const target2 = document.getElementById('detail-terrain')
          if (target && !target2) {
            setTimeout(() => {
              target.scrollIntoView({ behavior: 'smooth' })
            }, 800)
          }
        })
      } else {
        toastr.error(settings.messages.errors.retry)
      }
      loading(groundsMap, false)
    })
  },

  resize () {
    const map = document.getElementById(this.el)
    const h = document.getElementById('header').getBoundingClientRect()
    const w = window
    if (document.getElementById('desktopFilters')) {
      // avec filtres visibles
      const df = document.getElementById('desktopFilters').getBoundingClientRect()
      const mf = document.getElementById('mobileFilters').getBoundingClientRect()
      const go = document.getElementById('go')
      if (w.innerWidth > 991) {
        map.closest('section').classList.add('sticky-top')
        if (w.innerWidth > 1199) {
          map.closest('section').style.top = h.height + df.height + 'px'
          map.style.height = w.innerHeight - h.height - df.height + 'px'
        } else {
          map.closest('section').style.top = h.height + mf.height + 'px'
          map.style.height = w.innerHeight - h.height - mf.height + 'px'
        }
        go.style.marginTop = '-' + map.getBoundingClientRect().height + 'px'
        go.style.minHeight = w.innerHeight - h.height - mf.height - 75 + 'px'
      } else {
        map.closest('section').classList.remove('sticky-top')
        map.closest('section').style.top = 'inherit'
        if (w.innerWidth > 575) {
          map.style.height = '425px'
        } else {
          map.style.height = '275px'
        }
        go.style.marginTop = '0px'
        go.style.minHeight = 'inherit'
      }
    } else {
      // sans filtres
      const go = document.getElementById('go')
      if (w.innerWidth > 991) {
        map.closest('section').classList.add('sticky-top')
        map.closest('section').style.top = h.height + 'px'
        map.style.height = w.innerHeight - h.height + 'px'
        go.style.marginTop = '-' + map.getBoundingClientRect().height + 'px'
        go.style.minHeight = w.innerHeight - h.height + 'px'
      } else {
        map.closest('section').classList.remove('sticky-top')
        map.closest('section').style.top = 'inherit'
        if (w.innerWidth > 575) {
          map.style.height = '425px'
        } else {
          map.style.height = '275px'
        }
        go.style.marginTop = '0px'
        go.style.minHeight = 'inherit'
      }
    }
  },

  init () {
    const self = this
    this.resize()
    dtectMap(function () {
      // à exécuter une fois la GMap API correctement chargée
      self.buildMap()
    })
    window.addEventListener('resize', () => {
      self.resize()
    })
    document.addEventListener('scroll', () => {
      self.resize()
    })
  }
}

groundsMap.init()
